import blog1 from '../img/blogs/blog1.jfif';
import blog2 from '../img/blogs/blog4.svg';
import blog3 from '../img/blogs/10javascriptinterview.png';
import blog4 from '../img/blogs/10thingsreact.png';

const blogs = [
    {
        id: 1,
        image: blog1,
        title: '10 Javascript Interview Questions You need to know',
        link: 'https://mainulfahimnegetive.medium.com/10-javascript-interview-questions-you-need-to-know-7b0dc307ac65',
        date : '21',
        month: 'Mar',
        year: '2020'
    },
    {
        id: 2,
        image: blog2,
        title: '10 key things to know about Javascript',
        link: 'https://mainulfahimnegetive.medium.com/10-key-things-to-know-about-javascript-527d7a955a1d',
        date : '09',
        month: 'Dec',
        year: '2019'
    },
    {
        id: 3,
        image: blog3,
        title: 'Important Javascript methods you need to know',
        link: 'https://mainulfahimnegetive.medium.com/important-javascript-methods-you-need-to-know-13b6e5e610d',
        date : '15',
        month: 'Jun',
        year: '2018'
    },
    {
        id: 4,
        image: blog4,
        title: '10 things you should know about React',
        link: 'https://mainulfahimnegetive.medium.com/10-things-you-should-know-about-react-d0f3724d3744',
        date : '04',
        month: 'Aug',
        year: '2020'
    }
];

export default blogs;